var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("reference-layout", {
    staticClass: "function",
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("reference-header", {
              attrs: {
                "header-title": _vm.functionModel.id
                  ? "Редактирование функции"
                  : "Новая функция",
              },
              scopedSlots: _vm._u(
                [
                  _vm.functionModel.id
                    ? {
                        key: "header-title-action",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "function__info" },
                              [
                                _c("svg-icon", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.hover.blur.top",
                                      value: _vm.functionModel.status.title,
                                      expression: "functionModel.status.title",
                                      modifiers: {
                                        hover: true,
                                        blur: true,
                                        top: true,
                                      },
                                    },
                                  ],
                                  staticClass: "function__status",
                                  attrs: {
                                    name:
                                      "status-" + _vm.functionModel.status.code,
                                  },
                                }),
                                _c("div", { staticClass: "function__name" }, [
                                  _vm._v(_vm._s(_vm.functionModel.name)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      }
                    : null,
                  {
                    key: "header-actions",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "layout-header-action" },
                          [
                            _vm.functionModel.id
                              ? _c("c-button", {
                                  attrs: {
                                    size: "small",
                                    icon: "comment",
                                    label: "0 комментариев",
                                    tooltip: {
                                      text: "Комментарий",
                                      activeText: "Комментарий",
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "layout-header-action" },
                          [
                            _c("m-confirm", {
                              ref: "confirm",
                              attrs: { mode: "danger" },
                            }),
                            _vm.functionModel.id
                              ? _c("c-button", {
                                  attrs: {
                                    icon: { icon: "trash", color: "secondary" },
                                    size: "small",
                                    label: "Удалить",
                                  },
                                  on: { click: _vm.deleteFunction },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "layout-header-action" },
                          [
                            _c("c-button", {
                              attrs: {
                                size: "small",
                                label: "К списку функций",
                                icon: {
                                  icon: "back",
                                },
                                responsive: true,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push({ name: "functions" })
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "subheader",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "function__tabs" },
              [
                _c("c-tabs", {
                  attrs: { items: _vm.tabs.items, "with-routing": "" },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "list",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "function__content" },
              [_c("router-view", { ref: "route" })],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }